import { useScrollPosition } from '@cmpsr/components';
import { useState } from 'react';

// When using useSticky make sure any child components are wrapped in React.memo at export
export const useSticky = (navBarSize: number) => {
  const [isSticky, setIsSticky] = useState(false);
  useScrollPosition();

  const ref = (node: HTMLDivElement) => {
    if (!node || node.getBoundingClientRect().y > navBarSize) return setIsSticky(false);
    return setIsSticky(true);
  };

  return { ref, isSticky };
};
